import Image from 'next/image';
import type { ImageIconProps } from './types';

export const IconYoutube = ({ width, height, className }: ImageIconProps) => {
  return (
    <Image
      src='/images/ui/icons/youtube.svg'
      width={width}
      height={height}
      alt='Youtube'
      className={className}
    />
  );
};
